module.exports = __webpack_public_path__ + "static/media/cherry-1.cf5d484d.png";